<template>
  <div class="mobile-header">
    <div class="header-content">
      <div class="title-section">
        <h1 class="app-title">{{ title }}</h1>
        <div class="title-icon">📝</div>
      </div>
      <button class="settings-btn" @click="$emit('showSettings')">
        <i class="settings-icon">⚙️</i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileHeader',
  props: {
    title: {
      type: String,
      default: 'EasyNoteAI'
    }
  },
  emits: ['showSettings']
}
</script>

<style lang="less" scoped>
.mobile-header {
  background: white;
  padding: 12px 16px 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 200;
  
  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    
    .title-section {
      display: flex;
      align-items: center;
      gap: 8px;
      
      .app-title {
        font-size: 28px;
        font-weight: 700;
        color: #5065f6;
        margin: 0;
        background: linear-gradient(135deg, #5065f6, #8b5cf6);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }
      
      .title-icon {
        font-size: 24px;
      }
    }
    
    .settings-btn {
      width: 40px;
      height: 40px;
      border: none;
      border-radius: 20px;
      background: #f3f4f6;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: all 0.2s ease;
      
      &:active {
        background: #e5e7eb;
        transform: scale(0.95);
      }
      
      .settings-icon {
        font-size: 20px;
      }
    }
  }
}

// 适配状态栏高度
@supports (padding-top: env(safe-area-inset-top)) {
  .mobile-header {
    padding-top: calc(env(safe-area-inset-top) + 12px);
  }
}
</style> 